import { Play, Heart, Broadcast } from "@phosphor-icons/react";
import { TEST_IDS } from "@/constants/testIds";

export default function StationCard({ station, onPlay, onFav, isFav }) {
  return (
    <div data-testid={TEST_IDS.radio.stationCard} className="group glass-card p-4 sm:p-5 flex flex-col hover:border-cyan-300/30 hover:-translate-y-1 transition-all duration-200">
      <div className="flex items-start justify-between gap-3 mb-4">
        <div className="w-12 h-12 rounded-2xl border border-white/10 bg-white/[0.035] flex items-center justify-center overflow-hidden shrink-0 shadow-[0_0_22px_rgba(9,231,255,.08)]">
          {station.favicon ? (
            <img src={station.favicon} alt="" className="w-full h-full object-contain" onError={(e) => { e.target.style.display = "none"; }} />
          ) : (
            <Broadcast size={24} color="#09e7ff" weight="duotone" />
          )}
        </div>
        <button
          data-testid={TEST_IDS.radio.favBtn}
          onClick={() => onFav?.(station)}
          className={`w-10 h-10 rounded-full border flex items-center justify-center shrink-0 transition-colors ${isFav ? "border-[#ff4d1d]/60 text-[#ff4d1d] bg-[#ff4d1d]/10" : "border-white/10 text-slate-300/60 hover:border-[#ff4d1d]/60 hover:text-[#ff4d1d]"}`}
          aria-label={isFav ? "Remove favorite" : "Add favorite"}
        >
          <Heart size={16} weight={isFav ? "fill" : "regular"} />
        </button>
      </div>

      <h3 className="font-serif-display text-lg sm:text-xl font-semibold leading-tight mb-2 line-clamp-2 min-h-[3rem] break-words text-white">
        {station.name}
      </h3>

      <div className="font-mono text-[10px] uppercase tracking-[0.13em] text-slate-400 flex flex-wrap gap-x-2 gap-y-1 mb-4 min-w-0">
        <span className="truncate max-w-[8rem]">{station.country || "Worldwide"}</span>
        {station.language && <span className="truncate max-w-[6rem]">· {station.language.split(",")[0]}</span>}
        {station.bitrate ? <span>· {station.bitrate}kbps</span> : null}
      </div>

      <div className="flex flex-wrap gap-1.5 mb-4 min-h-[1.5rem]">
        {(station.tags || "World").split(",").filter(Boolean).slice(0, 2).map((t, i) => (
          <span key={i} className="recho-tag font-mono text-[9px] uppercase tracking-wider px-2 py-1 truncate max-w-[8rem]">
            {t.trim()}
          </span>
        ))}
      </div>

      <button
        data-testid={TEST_IDS.radio.playBtn}
        onClick={() => onPlay(station)}
        className="mt-auto w-full min-h-[44px] py-2.5 rounded-2xl border border-[#ff4d1d]/40 bg-[#ff4d1d]/10 text-[#ff7a18] hover:bg-[#ff4d1d] hover:text-white transition-colors font-mono text-[10px] sm:text-xs uppercase tracking-[0.16em] flex items-center justify-center gap-2"
      >
        <Play size={14} weight="fill" /> Tune in
      </button>
    </div>
  );
}
